import axios from '@/utils/axios.js'
/**
 * 获取菜单列表
 * @param {*} queryParams 查询参数
 * @returns 菜单列表
 */
export async function getMenus(queryParams) {
  const { data } = await axios.get('/admin/menu', { params: queryParams })
  return data
}

/**
 * 根据 id 查询菜单
 * @param {*} menuId 菜单 id
 * @returns 菜单
 */
export async function getMenuById(menuId) {
  const { data } = await axios.get(`/admin/menu/${menuId}`)
  return data
}

/**
 * 获取菜单树
 * @returns 菜单树
 */
export async function getMenuTree() {
  const { data } = await axios.get('/admin/menu/tree')
  return data
}

/**
 * 获取用户菜单列表
 * @returns 菜单列表
 */
export async function getMenusByUser() {
  const { data } = await axios.get('/admin/menu/user')
  return data
}

/**
 * 获取用户菜单树
 * @returns 菜单树
 */
export async function getMenuTreeByUser() {
  const { data } = await axios.get('/admin/menu/user/tree')
  return data
}

/**
 * 创建菜单
 * @param {*} menu 菜单
 */
export async function createMenu(menu) {
  await axios.post('/admin/menu', menu)
}

/**
 * 修改菜单
 * @param {*} menu 菜单
 */
export async function updateMenu(menu) {
  await axios.put('/admin/menu', menu)
}

/**
 * 根据 id 删除菜单
 * @param {*} menuId 菜单 id
 */
export async function deleteMenuById(menuId) {
  await axios.delete(`/admin/menu/${menuId}`)
}
